/* eslint-disable
    @trello/enforce-file-ownership,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const t = require('app/scripts/views/internal/teacup-with-helpers')(
  'connect_failed',
);

module.exports = function () {
  t.text(t.mustacheVar('msg'));
  t.br();
  return t.a(
    '.app-alert-item-button',
    { href: '#', onclick: 'window.location.reload()' },
    () => t.format('reload-page'),
  );
};
